/**
 * @render react
 * @name Tags
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withPolaris } from 'Components/protons/Polaris';

import { List } from 'Components/molecules/List';

import './_style.scss';

/**
 * Tags component
 * @param {array} content - Content to populate the List
 * @param {boolean} loadStyles - Whether to apply the class names for styling
 * @param {Object} extraClassNames - Extra class names to be applied to the component
 * @param {Object} context - Extra information coming from Polaris provider.
 */
const Tags = (
  {
    content,
    loadStyles,
    extraClassNames,
    context: { cssPrefix },
  },
) => (
  <div
    className={classNames({
      [`${cssPrefix}__tags`]: loadStyles,
      ...extraClassNames,
    })}
  >
    <List
      content={content}
      extraClassNames={{ [`${cssPrefix}__tags--list`]: true }}
    />
  </div>
);

/**
 * Valid props
 */
Tags.propTypes = {
  content: PropTypes.arrayOf(PropTypes.shape()),
  loadStyles: PropTypes.bool,
  extraClassNames: PropTypes.shape(),
  context: PropTypes.shape(),
};

/**
 * Default props
 */
Tags.defaultProps = {
  content: [],
  loadStyles: true,
  extraClassNames: {},
  context: {},
};

export default withPolaris(Tags);
